import { FC } from 'react';
import { UserAvatar, UserAvatarFirstLetter, UserAvatarImage } from './styled';

interface UserAvatarProps {
  profileImage?: string;
  name: string;
  ref?: any;
  onMouseEnter?: any;
}

const Avatar: FC<UserAvatarProps> = ({ name = '', profileImage, ref, onMouseEnter }) => {
  const nameFirstLetter = name ? name.charAt(0) : '';
  return (
    <UserAvatar variant="body1B" ref={ref} onMouseEnter={onMouseEnter}>
      {profileImage && profileImage?.length > 0 ? (
        <UserAvatarImage src={profileImage} alt={name} />
      ) : (
        <>
          <UserAvatarFirstLetter component={'span'}>{nameFirstLetter}</UserAvatarFirstLetter>
        </>
      )}
      {name}
    </UserAvatar>
  );
};

export default Avatar;
